
    <cookie-law-el *ngIf="!seen"
                   [awsomeCloseIcon]="awsomeCloseIcon"
                   [learnMore]="learnMore"
                   [target]="target"
                   [position]="position"
                   (isSeen)="hasBeenDismissed()"><ng-content></ng-content></cookie-law-el>
  


// WEBPACK FOOTER //
// ./node_modules/angular2-cookie-law/lib/cookie-law.component.d.ts.CookieLawComponent.html